import request from "@/utils/request";

/**
 * Gets deserialized custom fields answers
 */
export async function getDeserializedAnswers(
  groupId: number,
  ticketsAnswers: number[],
  bookingsAnswers: number[]
): Promise<any> {
  const response = await request({
    url: `/group/${groupId}/answers`,
    method: "post",
    data: { ticketsAnswers: ticketsAnswers, bookingsAnswers: bookingsAnswers },
  });

  return response.data;
}

/**
 * Gets deserialized custom fields question
 */
export async function getDeserializedCustomFieldQuestions(
  groupId: number,
  ticketFields: number[],
  bookingFields: number[]
): Promise<any> {
  const response = await request({
    url: `/group/${groupId}/customFieldsPos`,
    method: "post",
    data: { ticketFields: ticketFields, bookingFields: bookingFields },
  });

  return response.data;
}

/**
 * Get temporary url to a file (ticket custom field)
 */
export async function getTicketCustomFieldFile(
  bookingId: number,
  fieldAnswerId: number
): Promise<any> {
  const response = await request({
    url: `/booking/${bookingId}/ticket-field/${fieldAnswerId}/url`,
    method: "get",
    headers: { "Content-Type": "application/json" },
  });

  return response.data;
}

/**
 * Get temporary url to a file (booking custom field)
 */
export async function getBookingCustomFieldFile(
  bookingId: number,
  fieldAnswerId: number
): Promise<any> {
  const response = await request({
    url: `/booking/${bookingId}/booking-field/${fieldAnswerId}/url`,
    method: "get",
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data;
}
